
Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2
  if (t < 1) {
    return c / 2 * t * t + b
  }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
var requestAnimFrame = (function() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) { window.setTimeout(callback, 1000 / 60) }
})()

/**
 * Because it's so fucking difficult to detect the scrolling element, just move them all
 * @param {number} amount
 */
function move(amount,scrollBox) {
  if(scrollBox){
    scrollBox.scrollTop=amount;
    return;
  }
  document.documentElement.scrollTop = amount
  document.body.parentNode.scrollTop = amount
  document.body.scrollTop = amount
}

function position(scrollBox) { 
  return scrollBox&&scrollBox.scrollTop || document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop
}

export function getOffset(curEle) {
	let par = curEle.offsetParent,
		//获取当前元素的父参照物（不一定是父元素）
		l = curEle.offsetLeft,
		//获取当前元素相对父元素左偏离
		t = curEle.offsetTop;
		//获取当前元素相对父元素上偏移
	while (par && par.tagName !== 'BODY') {
		//判断是否已经到了最外一层 并且判断父参照物存不存在
		if (!/MSIE 8\.0/.test(navigator.userAgent)){
			//利用正则表达式判断
			l += par.clientLeft;
			t += par.clientTop;
		}
		l += par.offsetLeft;
		//获得元素距离父元素左偏移多少
		t += par.offsetTop;
		//获得元素距离父元素上偏移多少
		par = par.offsetParent;
	}
	return {
		top: t,
		left: l
	}
}
/**
* 判断元素是否在可视区域
* @param el
*/
export function isElementInViewport(el,contentBox){// 的判断div是否在可视区域
  if(contentBox){

    return getOffset(el).top>=0&&getOffset(el).left>=0
  }
   const rect = el.getBoundingClientRect();
   return (
       rect.top >= 0 &&
       rect.left >= 0 &&
       rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
       rect.right <= (window.innerWidth || document.documentElement.clientWidth)
   );
}
/**
 * @param {number} to
 * @param {number} duration
 * @param {Function} callback
 * @param {HTMLElement} scrollBox
 */
export function scrollTo({to, duration, callback,scrollBox}) {
  const start = position(scrollBox)
  // console.log({scrollBox},start,to);
  if(scrollBox){
    to=to-getOffset(scrollBox).top
  }
  const change = to - start
  const increment = 20
  let currentTime = 0
  duration = (typeof (duration) === 'undefined') ? 500 : duration
  var animateScroll = function() {
    // increment the time
    currentTime += increment
    // find the value with the quadratic in-out easing function
    var val = Math.easeInOutQuad(currentTime, start, change, duration)
    // move the document.body
    move(val,scrollBox)
    // do the animation unless its over
    if (currentTime < duration) {
      requestAnimFrame(animateScroll)
    } else {
      if (callback && typeof (callback) === 'function') {
        // the animation is done so lets callback
        callback()
      }
    }
  }
  animateScroll()
}

export function scrollIntoView(container, selected) {
  // if (Vue.prototype.$isServer) return;
  if (!selected) {
    container.scrollTop = 0;
    return;
  }
  const offsetParents = [];
  let pointer = selected.offsetParent;
  // console.log(pointer)
  while (pointer && container !== pointer && container.contains(pointer)) {
    offsetParents.push(pointer);
    pointer = pointer.offsetParent;
  }
  // console.log(offsetParents.reduce((prev, curr) => (prev + curr.offsetTop), 0))
  const top = selected.offsetTop + offsetParents.reduce((prev, curr) => (prev + curr.offsetTop), 0);
  const bottom = top + selected.offsetHeight;
  const viewRectTop = container?container.scrollTop:0;
  const viewRectBottom = viewRectTop + container.clientHeight;
  if (top < viewRectTop) {
    container.scrollTop = top;
  } else if (bottom > viewRectBottom) {
    container.scrollTop = bottom - container.clientHeight;
  }
}


// WEBPACK FOOTER //
// ./src/util/scroll/scroll-to.js